var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'preview')?_c('div',_vm._l((_vm.questions),function(question,index){return _c('div',{key:`get-question-${question.id}`},[_c('Preview',{attrs:{"question":question,"index":index}})],1)}),0):_c('Drag',{on:{"set-type":_vm.setType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }